import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@separate/components/Spinner';
import { useListPaymentMethods } from '@separate/hooks/premium';
import { useTranslation } from '@separate/hooks/translation';
import AddNewCard from './AddNewCard';
import AddNewCardOffcanvas from './AddNewCardOffcanvas';
import PaymentMethodInfoCard from './PaymentMethodInfoCard';
import styles from './paymentMethods.module.scss';

export default function PaymentMethods({ container }) {
  const { t } = useTranslation();

  const { isLoading, data } = useListPaymentMethods();
  const payment_methods = data?.payment_methods;

  const [show, setShow] = React.useState(false);

  return (
    <>
      <h4 className={styles.ctaTitle}>{t('user.profile.payment_methods')}</h4>
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      ) : (
        <>
          {payment_methods && payment_methods.map((method, idx) => {
            return (
              <PaymentMethodInfoCard method={method} key={method.id} primary={idx === 0} />
            );
          })}
          <AddNewCard onClick={() => setShow(true)} />
          <AddNewCardOffcanvas
            container={container}
            onHide={() => setShow(false)}
            show={show}
          />
        </>
      )}
    </>
  );
}

PaymentMethods.propTypes = {
  container: PropTypes.any,
};
